import React, { useCallback, useContext } from 'react';
import classNames from 'classnames';
import GetAndUploadTemplate from 'components/GetAndUploadTemplate';
import { FILE_TYPES } from 'router/subrouters/DataRoom/components/DataRoomDocumentsRouter/data/DataTypes';
import { useTranslation } from 'react-i18next';
import api from 'api';
import PopNotificationsContext from 'providers/PopNotifications/PopNotifications.context';
import useCallbackAsync from 'hooks/useCallbackAsync';
import utils from 'utils';
import { DataRoomSheet } from 'router/subrouters/DataRoom/models/DataRoom';
import { SHEET_FILE_TYPES } from 'data/global';

import './BulkUploadDataRooms.styles.scss';
import './BulkUploadDataRooms.styles.responsive.scss';

const FILE_NAME = 'dataRooms';

const FIELDS = [
  { field: 'dataRoomName', description: 'dataRoomName' },
  { field: 'ownersName', description: 'ownersName' },
  { field: 'ownersEmail', description: 'ownersEmail' },
  {
    field: 'colleaguesEmails',
    description: 'colleaguesEmailsCommaSeparatedList',
  },
];

type BulkUploadDataRoomsProps = {
  className?: string;
  onUpload?: (data: DataRoomSheet[]) => void;
};

const BulkUploadDataRooms: React.FC<BulkUploadDataRoomsProps> = (props) => {
  const { className, onUpload } = props;

  const { popServerError } = useContext(PopNotificationsContext);

  const classes = classNames(
    'bulk-upload-data-rooms',
    'white-panel',
    className,
  );

  const { t } = useTranslation();

  const uploadSheet = useCallback(
    async (file, fileName, config) => {
      try {
        const { data } = await api.dataRoom.access.uploadSheet(
          file,
          fileName,
          config,
        );
        onUpload?.(data);
      } catch (e) {
        popServerError(e);
      }

      return null;
    },
    [onUpload, popServerError],
  );

  const [downloadTemplate, isDownoadingTemplate] = useCallbackAsync(
    async () => {
      const { data } = await api.dataRoom.access.getSheetTemplate();

      utils.downloadUrl({
        type: FILE_TYPES.DOCUMENT_XLSX,
        href: data,
      });
    },
  );

  return (
    <div className={classes}>
      <p>{t('dataRoomBulkUpload')}</p>
      <p>{t('dataRoomBulkUploadDescription')}</p>

      <GetAndUploadTemplate
        fileName={FILE_NAME}
        fields={FIELDS}
        supportedFileTypes={SHEET_FILE_TYPES}
        isDownoadingTemplate={isDownoadingTemplate}
        showColumnsTemplate={false}
        downloadTemplate={downloadTemplate}
        uploadRequest={uploadSheet}
      />
    </div>
  );
};

export default BulkUploadDataRooms;
